module.exports = __webpack_public_path__ + "static/img/off.bfe53e68.png";